import type { MouseEventHandler } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';

type ActionMenuFooterProps = {
  handleCancelButtonClick: MouseEventHandler<HTMLButtonElement>;
  handleConfirmButtonClick: MouseEventHandler<HTMLButtonElement>;
};

const ActionMenuFooter = ({
  handleCancelButtonClick,
  handleConfirmButtonClick,
}: ActionMenuFooterProps) => {
  return (
    <ConfirmButtonWrapper>
      <Button sizeType="m" variant="outlined" onClick={handleCancelButtonClick}>
        Cancel
      </Button>
      <Button sizeType="m" onClick={handleConfirmButtonClick}>
        Confirm
      </Button>
    </ConfirmButtonWrapper>
  );
};

const ConfirmButtonWrapper = styled(Flex).attrs({
  a: 'center',
  j: 'flex-end',
  g: '6px',
})`
  height: 62px;
  padding: 16px 20px;
`;

export default ActionMenuFooter;
